// delta2-04 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Consulte o sistema": "Consulte el sistema",
    "Locais de troca:": "Locales de canje:",
    "Loja %{arg1}": "Local %{arg1}",
};

export default catalogo;
